import {HttpAxiosRequest} from "../httpAxiosBase";
import {ClientUserDTO} from "../../types/client/clientData";


export const HttpClientUser = {
    getEndpoint: (url = "") => `usuario-clientes${url}`,
    
    getCompanies: () : Promise<ClientUserDTO[]> => {
        return HttpAxiosRequest.get(
            HttpClientUser.getEndpoint("")
        )
    },
    
    insert: (clientId: number) : Promise<any> => {
        return HttpAxiosRequest.post(
            HttpClientUser.getEndpoint(`/${clientId}`),
            {}
        )
    }
}